import React from 'react';

export default function RecoveryCodeModal({ recoveryCode, onConfirm }) {
  return (
    <div
      data-testid="modal-overlay"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: 24,
      }}
    >
      <div style={{
        background: 'var(--color-surface)',
        padding: '40px 36px',
        width: '100%',
        maxWidth: 400,
        borderRadius: 4,
        textAlign: 'center',
      }}>
        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 24,
          fontWeight: 400,
          color: 'var(--color-text)',
          marginBottom: 8,
        }}>
          Your Recovery Code
        </h2>

        <p style={{
          fontSize: 12,
          color: 'var(--color-muted)',
          fontFamily: 'var(--font-body)',
          marginBottom: 24,
          lineHeight: 1.6,
        }}>
          Save this somewhere safe — your password manager, notes app, or printed paper.
          You'll need it if you ever forget your password.
          <strong style={{ display: 'block', marginTop: 8, color: 'var(--color-text)' }}>
            This code will not be shown again.
          </strong>
        </p>

        <div style={{
          background: 'rgba(212, 168, 67, 0.1)',
          border: '1px solid var(--color-accent)',
          borderRadius: 4,
          padding: '16px 24px',
          marginBottom: 28,
          fontFamily: 'monospace',
          fontSize: 22,
          letterSpacing: '0.1em',
          color: 'var(--color-accent)',
        }}>
          {recoveryCode}
        </div>

        <button
          onClick={onConfirm}
          style={{
            width: '100%',
            padding: '14px 20px',
            background: 'var(--color-accent)',
            color: '#fff',
            border: 'none',
            fontSize: 13,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            fontFamily: 'var(--font-body)',
            borderRadius: 4,
            fontWeight: 600,
          }}
        >
          I've saved my recovery code
        </button>
      </div>
    </div>
  );
}
